const BASE_URL = '/backend-api';
const WS_BASE_URL = BASE_URL.replace(/^http(s)?:\/\//, 'wss://');

export const environment = {
  BASE_URL,
  THEME: 'aura-light-noir.css',
  CLEARING_API_ENDPOINT: `${BASE_URL!}/partner-api/v1`,
  CLEARING_CUSTOM_API_ENDPOINT: `${BASE_URL!}/clearing-api/v1`,
  MESSAGE_BROKER_URL: `${WS_BASE_URL}/ws`,
  LIGHT_PARTNER_API_PATH: '/light',
  SEARCH_ENDPOINT: `${BASE_URL!}/search`,
  PARTNERSHIP_APP_URL:
    'https://nco.clearing.bitconex.com/partnership/',
  ITU_CODE: [
    'DEU.EASYBL',
    'DEU.TEL2DE',
    'DEU.ECOTEL',
    'DEU.FLNFON',
    'DEU.DETEST',
    'DEU.SIS',
    'DEU.AVAYA',
    'DEU.PFONE',
    'DEU.VSENET',
    'DEU.COLTDE',
    'DEU.HFO',
    'DEU.SG',
    'DEU.NETCO',
    'DEU.NETAC',
    'DEU.REVTIX',
    'DEU.FLOBX',
    'DEU.BITEL',
    'DEU.BTG',
    'DEU.FONIAL',
    'DEU.STAR'
  ],
  OWNER_SUB_ENTITIES: [],
  KEYCLOAK: {
    URL: 'https://keycloak.clearing.bitconex.com',
    REALM: 'clearing-realm-nco',
    CLIENT_ID: 'clearing-gui-client',
    REDIRECT_URI: 'https://nco.clearing.bitconex.com/',
  },
};
